module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-18-e2de0dbae0c8142bacb17c572bcb6ac6.jpg";